/*
 * tooltips handles the closing and opening of tooltips
 *
 * GDL Requirements
 * - Desktop: Bij mouseover al de informatietekst tonen https://novamedia-jira.atlassian.net/browse/VLC-3615
 * - Mobiel: Bij klikken tekst tonen danwel verbergen https://novamedia-jira.atlassian.net/browse/VLC-3615
 * - when a tooltip is open and it's corresponding input is focused, the tooltip is closed
 * - Modernizr met fallback vastgesteld: https://novamedia-jira.atlassian.net/browse/BGLC-3216
 */

const tooltips = () => {
  if ($('.tooltip-icon').length === 0) {
    return;
  }

  /* On any browsers that don't get modernizr, just use click, since it's likely an old tablet or mobile */
  const isTouchEvents = window.Modernizr.touchevents !== undefined ? window.Modernizr.touchevents : true;

  $('.tooltip-icon').on('click', function handleClick() {
    if (isTouchEvents) {
      const dataTarget = $(this).data('target');
      const $target = $(`#${dataTarget}`);
      if ($(this).hasClass('open')) {
        $target.hide();
        $(this).removeClass('open');
      } else {
        $target.show();
        $(this).addClass('open');
      }
    }
  });

  $('.tooltip-icon').on('mouseenter', function handleMouseEnter() {
    if (!isTouchEvents) {
      const dataTarget = $(this).data('target');
      const $target = $(`#${dataTarget}`);
      $target.show();
      $(this).addClass('open');
    }
  });

  $('.tooltip-icon').on('mouseout', function handleMouseOut() {
    if (!isTouchEvents) {
      const dataTarget = $(this).data('target');
      const $target = $(`#${dataTarget}`);
      $target.hide();
      $(this).removeClass('open');
    }
  });

  $('input').on('focusin', function handleFocusIn() {
    const $questionIcon = $(this).closest('.form-group').find('.tooltip-icon');
    const $questionInfo = $(this).closest('.form-group').find('.tooltip-info');

    if (!$questionIcon.length === 0 && !$questionInfo.length === 0) {
      $questionIcon.removeClass('open');
      $questionInfo.hide();
    }
  });
};

export default tooltips;
